import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'

import '../scss/main.scss'
import 'typeface-exo'
import 'typeface-roboto'

import ActionButtonContainer from '../containers/ActionButtonContainer'
import RemarkScreenContainer from '../containers/RemarkScreenContainer'

import MainFooter from '../components/MainFooter'
import MainHeader from '../components/MainHeader'

class DefaultLayout extends React.Component {

  render() {
    return (
      <div className="l-page-wrapper">
        <Helmet
          title="I'm a Web app developer"
          meta={[{ 
            name: 'description', 
            content: "I build Web apps using: " +
            "Javascript, ES6+, Webpack, Babel, Gatsby, React, Redux, HTML5 and CSS3. " +
            "My platform experience includes AWS Services and Google Cloud Platform. " +
            "Along with languages including Python, C#, Java, C++."
          }]}
        />
          
        <div className={`l-page-container ${this.props.remarkScreenisActive && 'is-blurred'}`}>
          <MainHeader />
          <main className="l-main">
            {this.props.children()}
          </main>
          <MainFooter />
        </div>
        {
          (this.props.location.pathname === '/'
          || this.props.location.pathname === '/contact/') 
          && 
          <ActionButtonContainer 
            locationPathName={this.props.location.pathname}
          />
        }  
        <RemarkScreenContainer 
          locationPathName={this.props.location.pathname}
        />
      </div>
    )
  }  
}

export default connect(
  (state, ownProps) => ({ remarkScreenisActive: state.remarkScreen.isActive })
)(DefaultLayout)




// WEBPACK FOOTER //
// ./src/layouts/index.jsx